import {Dispatch} from 'react'
import {COMPROBANTE_RETENCION_TYPES} from '../../constants/comprobanteRetencion.types'
import * as validacionesRegex from '../../utils/strings.utils'
import * as validators from '../../utils/validaciones'
import * as reg from '../../constants/Regex'
import {
getDepartamentos, getMunicipios, getTiposDocumento, setMunicipios,} from '../catalogos.actions'
import {State} from '../../reducers'
import {comprobanteRetencionInitialState} from '../../initital-state/comprobanteRetencion.state'
import {comprobanteRetencionGetDatosEmisor} from './comprobanteRetencionEmision.actions'
import {CREClienteF, ComprobanteRetencionAction} from '../../interfaces/comprobante-retencion.interface'

// ******************************************************************************************

export const comprobanteRetencionFormClienteHandleChange = (formCliente: CREClienteF) => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMCLIENTE_HANDLE_CHANGE,
  payload: formCliente,
})

export const comprobanteRetencionFormClienteAddError = (formError: CREClienteF) => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMCLIENTE_SET_ERRORS,
  payload: formError,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const comprobanteRetencionFormClienteHandleChangeInputPhone = (phone: string) =>
  async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
    dispatch(comprobanteRetencionFormClienteHandleChange({telefono: phone}))
  }

export const comprobanteRetencionFormClienteHandleChangeInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
    const {tipoDocumento} = getState().comprobanteRetencion.formCliente
    let {name, value} = e.target
    switch (name) {
      case 'fecha':
        break
      case 'tipoDocumento':
        const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
        dispatch(comprobanteRetencionFormClienteHandleChange({numId: ''}))
        dispatch(comprobanteRetencionFormClienteAddError({numId: ''}))
        if (tipoDoc) dispatch(comprobanteRetencionFormClienteHandleChange({nombreTipoDocumento: tipoDoc.valor}))
        else {
          dispatch(comprobanteRetencionFormClienteHandleChange({nombreTipoDocumento: ''}))
          dispatch(comprobanteRetencionFormClienteAddError(comprobanteRetencionInitialState.errorsFormCliente))
        }
        break
      case 'numId':
        if((tipoDocumento === "36" || tipoDocumento === "13") && !validacionesRegex.validarRegexNumericoInt(value) ) return
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return
        break
      case 'nombre':
        if (!validacionesRegex.validarRegexNombresCliente(value)) return
        break
      case 'departamento':
        const depto = getState().catalogos.departamentos.find((doc) => value === doc.codigo)
        if (depto)
          dispatch(comprobanteRetencionFormClienteHandleChange({nombreDepartamento: depto.valor}))
        else dispatch(comprobanteRetencionFormClienteHandleChange({nombreDepartamento: ''}))
        dispatch(comprobanteRetencionFormClienteHandleChange({municipio: '', direccion: ''}))
        dispatch(comprobanteRetencionFormClienteAddError({municipio: '', direccion: ''}))
        break
      case 'municipio':
        const muni = getState().catalogos.municipios.find((doc) => value === doc.codigo)
        dispatch(comprobanteRetencionFormClienteHandleChange({nombreMunicipio: muni ? muni.valor : ''}))
        dispatch(comprobanteRetencionFormClienteHandleChange({direccion: ''}))
        dispatch(comprobanteRetencionFormClienteAddError({direccion: ''}))
        break
      case 'direccion':
      case 'email':
      case 'telefono':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'actividad':
        let actividad = getState().catalogos.actividadesEconomicas.find((act) => act.codigo === value)
        dispatch(comprobanteRetencionFormClienteHandleChange({descripcion: actividad ? actividad.valor : ''}))
        break
      case 'nrc':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return
        break
      default:
        break
    }
    dispatch(comprobanteRetencionFormClienteHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const comprobanteRetencionConsultarCatalogos = () => async (dispatch: Dispatch<any>) => {
  try {
    Promise.all([
      dispatch(getDepartamentos()),
      dispatch(getTiposDocumento()),
      dispatch(comprobanteRetencionGetDatosEmisor()),
    ])
  } catch (error) {}
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const comprobanteRetencionFormClienteOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const {chipsEmail} = getState().comprobanteRetencion.formCliente
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'fecha':
        break
      case 'numId':
        message = validators.validacionEsRequerido( value, message, getState().comprobanteRetencion.formCliente.nombreTipoDocumento)
        if (!message) message = validators.validacionMinLenght(value, message, 9)
        if (!message) message = validators.validarTipoDocumento(getState().comprobanteRetencion.formCliente.nombreTipoDocumento!, value, message)
        break
      case 'nombre':
        message = validators.validacionEsRequerido(value, message, 'Nombre')
        break
      case 'departamento':
        message = validators.validacionEsRequerido(value, message, 'Departamento')
        // Obtener el catálogo de municipio
        const depto = getState().comprobanteRetencion.formCliente.nombreDepartamento
        if (depto) await dispatch(getMunicipios(Number(value), depto, true))
        else dispatch(setMunicipios([]))
        dispatch(comprobanteRetencionFormClienteHandleChange({ municipio: '', nombreMunicipio: '', }))
        break
      case 'municipio':
        message = validators.validacionEsRequerido(value, message, 'Municipio')
        break
      case 'direccion':
        message = validators.validacionEsRequerido(value, message, 'Dirección')
        if (!message) message = validators.validacionMinLenght(value, message, 5)
        break
      case 'email':
        if (!chipsEmail?.length) {
          message = validators.validacionEsRequerido(value, message, 'Correo electrónico')
        }
        if (!message && value) message = validators.validacionEmail(value, message, 'Correo electrónico')
        break
      case 'telefono':
        if (!message) message = validators.validacionMinLenght(value, message, 8)
        if (!message) message = validators.validacionRegex(reg.REGEX_TELEFONO, value, message, 'Teléfono celular')
        break
      case 'actividad':
        message = validators.validacionEsRequerido(value, message, 'Actividad', 'requerida')
        let actividad = getState().catalogos.actividadesEconomicas.find((act) => act.codigo === value)
        dispatch(comprobanteRetencionFormClienteHandleChange({descripcion: actividad ? actividad.valor : ''}))
        break
      case 'nrc':
        message = validators.validacionEsRequerido(value, message, 'NRC')
        if (!message) message = validators.validacionMinLenght(value, message, 2)
        if (!message) message = validators.validacionRegex(reg.REGEX_NRC, value, message, 'NRC')
        break
      default:
        break
    }
    dispatch(comprobanteRetencionFormClienteAddError({[name]: message}))
  }

export const comprobanteRetencionFormClienteValidacionesGenerarFactura = (dispatch: Dispatch<ComprobanteRetencionAction>,getState: () => State) => {
  const {formCliente, errorsFormCliente} = getState().comprobanteRetencion

  errorsFormCliente.numId = validators.validacionEsRequerido(formCliente.numId!,errorsFormCliente.numId!,getState().comprobanteRetencion.formCliente.nombreTipoDocumento)
  if (!errorsFormCliente.numId) errorsFormCliente.numId = validators.validacionMinLenght( formCliente.numId!, errorsFormCliente.numId, 3)
  if (!errorsFormCliente.numId) errorsFormCliente.numId = validators.validarTipoDocumento(getState().comprobanteRetencion.formCliente.nombreTipoDocumento!,formCliente.numId!,errorsFormCliente.numId)

  errorsFormCliente.nombre = validators.validacionEsRequerido(formCliente.nombre!,errorsFormCliente.nombre!,'Nombre')

  errorsFormCliente.departamento = validators.validacionEsRequerido(formCliente.departamento!,errorsFormCliente.departamento!,'Departamento')

  errorsFormCliente.municipio = validators.validacionEsRequerido(formCliente.municipio!,errorsFormCliente.municipio!,'Municipio')

  errorsFormCliente.direccion = validators.validacionEsRequerido(formCliente.direccion!,errorsFormCliente.direccion!,'Dirección')
  if (!errorsFormCliente.direccion) errorsFormCliente.direccion = validators.validacionMinLenght(formCliente.direccion!,errorsFormCliente.direccion!,5)

  if (!formCliente.chipsEmail?.length) {
    errorsFormCliente.email = validators.validacionEsRequerido(
      formCliente.email!,
      errorsFormCliente.email!,
      'Correo electrónico'
    )
  }
  
  if (!errorsFormCliente.email && formCliente.email) {
    errorsFormCliente.email = validators.validacionEmail(
      formCliente.email!,
      errorsFormCliente.email!,
      'Correo electrónico'
    )
  }


  errorsFormCliente.telefono = validators.validacionEsRequerido(formCliente.telefono!,errorsFormCliente.telefono!,'Teléfono celular')
  if (!errorsFormCliente.telefono) errorsFormCliente.telefono = validators.validacionMinLenght(formCliente.telefono!,errorsFormCliente.telefono!,8)
  if (!errorsFormCliente.telefono) errorsFormCliente.telefono = validators.validacionRegex(reg.REGEX_TELEFONO, formCliente.telefono!,errorsFormCliente.telefono!,'Teléfono celular')

  
  errorsFormCliente.actividad = validators.validacionEsRequerido(formCliente.actividad!, errorsFormCliente.actividad!, 'Actividad', 'requerida')

  errorsFormCliente.nrc = validators.validacionEsRequerido(formCliente.nrc!, errorsFormCliente.nrc!, 'NRC')
  if (!errorsFormCliente.nrc) errorsFormCliente.nrc = validators.validacionMinLenght(formCliente.nrc!, errorsFormCliente.nrc!, 2)
  if (!errorsFormCliente.nrc) errorsFormCliente.nrc = validators.validacionRegex(reg.REGEX_NRC,formCliente.nrc!,errorsFormCliente.nrc!,'nrc')
  

  dispatch(comprobanteRetencionFormClienteAddError(errorsFormCliente))

  const hasErrors = Object.values(errorsFormCliente).some(error => error);
  if (hasErrors) return true;
  return false
}

export const validacionDisabled = (form: CREClienteF, errors:CREClienteF) => {
  const newForm = {...form}
  delete newForm.fecha
  delete newForm.nombreTipoDocumento
  delete newForm.nombreDepartamento
  delete newForm.nombreMunicipio
  delete newForm.descripcion
  const hasForm = Object.values(newForm).every(value => value);
  const hasErrors = Object.values(errors).some(error => error);
  return !(hasForm && !hasErrors)
}